// extracted by mini-css-extract-plugin
export default {"alert":"QcZ_gxS6EACcNK409m67","content":"O3cCB830oetfVQXkwwPY"};